import React, { useEffect } from 'react';
import './MyTeamMembers.scss';
import AssociateMembersTable from '../../../Associates/AssociateMembersTable';
import { useStateSelector } from '../../../../store/selectors';
import { useDispatch } from 'react-redux';
import { FetchSummary } from '../../../../slices/user-summary/fetch-summary.thunk';

export const MyTeamMembers = () => {
    useEffect(() => {}, []);
    const summary = useStateSelector((state) => state.userSummary.summary);
    const currentUser = useStateSelector((s) => s.currentUser);
    const dispatch: any = useDispatch();

    const fetchUserData = async () => {
        dispatch(FetchSummary());
    };

    return (
        <div className="my-members-table">
            {currentUser?.user?.id ? (
                <AssociateMembersTable
                    currentUserId={currentUser?.user?.id}
                    summaryData={summary}
                    isMarketplaceBuyer={summary.isMarketplaceBuyer}
                    isShortView={true}
                    getSummaryData={fetchUserData}/>
            ) : (
                <></>
            )}
        </div>
    );
};
